import { createReducer, on } from '@ngrx/store';
import { signIn, signInSuccess, signInFailure, logout } from '../actions/auth.actions';
import { AuthState } from '../../shared/models/auth.model';

export const initialState: Partial<AuthState> = {
  user: null, 
  loading: false,
  error: null,
};

export const authReducer = createReducer(
  initialState,

  on(signIn, (state) => ({ ...state, loading: true, error: null })),

  on(signInSuccess, (state, { response }) => ({
    ...state,
    user: response.user, 
    loading: false,
    error: null,
  })),

  on(signInFailure, (state, { error }) => ({
    ...state,
    user: null, 
    loading: false,
    error,
  })),

  on(logout, () => initialState)
);
